import { InputAdornment, MenuItem, Select, Stack, TextField } from '@mui/material';
import { useState } from 'react';
import { useDebounce } from 'react-use';
import { SearchSM } from 'untitledui-js-base';
import { FiltersType } from '../hooks';
import { AccidentStatusResponse } from '../types/accident';

export interface AccidentFiltersType {
  search: string;
  statusId: number | undefined;
}

export interface AccidentsFiltersProps {
  filters: FiltersType<AccidentFiltersType>;
  statuses?: AccidentStatusResponse[];
  disabled?: boolean;
}

export const AccidentsFilters = ({ filters: { filters, setFilters }, statuses, disabled }: AccidentsFiltersProps) => {
  const [searchInput, setSearchInput] = useState(filters.search);

  useDebounce(
    () => {
      if (searchInput !== filters.search) {
        setFilters({ ...filters, search: searchInput });
      }
    },
    2000,
    [searchInput]
  );

  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ md: 'center' }}
      spacing={{ xs: 1, md: 2 }}
      width={{ xs: 1, md: 'auto' }}
    >
      <TextField
        placeholder="Vyhledat v nehodách"
        variant="outlined"
        value={searchInput}
        size="small"
        disabled={disabled}
        sx={{ minWidth: 320 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchSM color="currentColor" />
            </InputAdornment>
          ),
          sx: { backgroundColor: 'background.paper' }
        }}
        onChange={(e) => setSearchInput(e.target.value)}
      />
      {!!statuses?.length && (
        <Select
          size="small"
          displayEmpty
          disabled={disabled}
          value={filters.statusId ?? ''}
          sx={{ minWidth: 200, backgroundColor: 'background.paper' }}
          onChange={(e) =>
            setFilters({
              ...filters,
              statusId: e.target.value === '' ? undefined : Number(e.target.value)
            })
          }
        >
          <MenuItem value="">Vyberte stav...</MenuItem>
          {statuses.map((status) => (
            <MenuItem key={status.id} value={status.id}>
              {status.label}
            </MenuItem>
          ))}
        </Select>
      )}
    </Stack>
  );
};
